import React from "react";
import Report from "components/Report";

export default function Analatics() {
  return <Report type="scholarship" />;
}
